<template>
  <span v-resize="checkMobile" :style="isMobile ? 'padding: 5px !important;' : ''">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="contractors-page">
      <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
        <v-flex class="d-flex align-center justify-space-between">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
            hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="showNewContractorDialog = true" class="mx-2">
            {{ $t("contractors.add_contractor") }}
          </v-btn>
          <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
            }/${$root.$i18n.locale}/categories/4/guides/14`" target="_blank">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
        </v-flex>
      </v-toolbar>
      <v-data-table :headers="headers" :items="contractors" :search="search" :loading="isLoading"
        :loading-text="$t('custom.loading_table')" :items-per-page="50" mobile-breakpoint="100" sort-by="id" sort-desc
        :class="!isMobile ? '' : 'is-mobile'" dense :footer-props="tableFooterProps([50, 100, 200], `{0} ${$t('custom.of')} ${total}`)">
        <template slot="item" slot-scope="props">
          <tr @dblclick="replaceToContractor(props.item)" style="cursor: pointer">
            <td class="text-center" :key="props.item.id">
              {{ props.item.id }}
            </td>
            <td class="text-center">
              {{ props.item.full_name }}
            </td>
            <td class="text-center">
              {{ props.item.short_name }}
            </td>
            <td class="text-center">
              {{ props.item.entity_type }}
            </td>
            <td class="text-center">
              {{ props.item.tax_number }}
            </td>
            <td class="text-center">
              {{ props.item.tin_number }}
            </td>
            <td class="text-center">
              {{ props.item.phone }}
            </td>
            <td class="text-center">
              <v-icon small class="mr-2" @click="replaceToContractor(props.item)"
                :title="$t('contractors.go_to_contractor')">
                mdi-eye-outline
              </v-icon>
              <v-icon small @click="deleteItem(props.item)" v-if="isAdminPlus">
                mdi-delete-forever
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t("custom.no_data_in_table") }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
          {{ $t("tables.no_search_result", { msg: search }) }}
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showNewContractorDialog" :retain-focus="false" persistent max-width="1200px"
      :fullscreen="isMobile">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("contractors.add_contractor") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showNewContractorDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-container v-if="contractor">
              <v-layout row wrap>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.full_name" :label="$t('custom.company_name')"
                    :placeholder="$t('custom.company_name_placeholder')" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.short_name" :label="$t('custom.company_name_short')"
                    :placeholder="$t('custom.company_name_short_plc')" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.entity_type" :label="$t('custom.reg_form')"
                    :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field v-model.trim="contractor.tax_number" :label="$t('custom.tax_number')"
                    outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field v-model.trim="contractor.tin_number" :label="$t('custom.entity_number')"
                    outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field v-model.trim="contractor.phone" :label="$t('custom.phone')" type="tel"
                    outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field v-model.trim="contractor.email" :label="$t('custom.email')" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.account" :label="$t('custom.entity_bank_number')"
                    outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.bank_name" :label="$t('custom.bank_name')"
                    :placeholder="$t('custom.bank_name_plc')" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field v-model.trim="contractor.bank_number" :label="$t('custom.bank_number')"
                    outlined></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-textarea v-model.trim="contractor.address" :label="$t('custom.entity_address')" outlined rows="1"
                    auto-grow></v-textarea>
                </v-flex>
                <v-flex md12>
                  <v-textarea v-model.trim="contractor.description" :label="$t('custom.description')" outlined rows="1"
                    auto-grow></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="saveNewContractor()">{{ $t("custom.save") }}</v-btn>
          <v-btn @click="showNewContractorDialog = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { saveAs } from "file-saver";
import PullToRefresh from "pulltorefreshjs";
export default {
  data() {
    return {
      contractors: [],
      contractor: {},
      search: null,
      headers: [
        {
          text: this.$t("custom.number"),
          align: "center",
          value: "id",
        },
        {
          text: this.$t("custom.company_name"),
          align: "center",
          value: "full_name",
        },
        {
          text: this.$t("custom.company_name_short"),
          align: "center",
          value: "short_name",
        },
        {
          text: this.$t("custom.reg_form"),
          align: "center",
          value: "entity_type",
        },
        {
          text: this.$t("custom.tax_number"),
          align: "center",
          value: "tax_number",
        },
        {
          text: this.$t("custom.entity_number"),
          align: "center",
          value: "tin_number",
        },
        {
          text: this.$t("custom.phone"),
          align: "center",
          value: "phone",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
      ],
      showNewContractorDialog: false,
      timeout: null,
      total: 0,
      isMobile: false,
      isLoading: true,
      error: "",
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get("/api/v1/contractors", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.contractors.push(element.attributes);
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.branch_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
  },
  methods: {
    saveNewContractor() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(
            "/api/v1/contractors",
            {
              contractors: this.contractor,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.contractors.push(response.data);
            this.$notify(this.$t("custom.saved"), this.$t("contractors.contractor_added"), "success", 3000);
            this.showNewContractorDialog = false;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async deleteItem(contractor) {
      if (this.isStaff) {
        const confirmed = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.you_sure_no"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 450,
        });
        
        if (confirmed) {
          this.isLoading = true;
          this.axios
            .delete(`/api/v1/contractors/${contractor.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then(() => {
              this.contractors.splice(this.contractors.indexOf(contractor), 1);
              this.$notify(this.$t("custom.deleted"), "", "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"))
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    replaceToContractor(contractor) {
      this.$router.push({ path: `/contractors/${contractor.id}` });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
